import React from 'react';
import {
  AppstoreOutlined,
  BarChartOutlined,
  CloudOutlined,
  ShopOutlined,
  TeamOutlined,
  UploadOutlined,
  UserOutlined,
  VideoCameraOutlined,
} from '@ant-design/icons';
import { Layout, Menu, theme, Input, Typography, Button, Avatar } from 'antd';
import Sidebar from '../../../layout/Sidebar';
import NavBar from '../../../layout/NavBar';
import FooterLayout from '../../../layout/Footer';

const { Header, Content, Footer, Sider } = Layout;

const Notifications = () => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  return (
    <p>Content of Developer Account</p>
  );
};
export default Notifications;